import React from 'react';
import { AdornmentInput, QuestionMark, SubmitButton, CustomLink, InputWrapper } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ButtonWrapper, Information } from '../Elements';
import { CreditPaymentHelp } from '../Help';
import useCreditPayment from './hooks/useCreditPayment';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl?: string | Array<string>;
  progress?: number;
  flow?: FlowEnum;
}

const CreditPayment: React.FC<Props> = (props: Props) => {
  const { progress, flow, nextUrl } = props;

  const { classes, t, toggleHelpModal, onSkip, onAmountChange, onSubmit, amount } = useCreditPayment(nextUrl);

  return (
    <MainLayout
      navigationId={ComponentsEnum.PAYMENT_TYPE}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="payment_type_credit_page_title"
    >
      <HelpModal>
        <CreditPaymentHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t('payment_type_credit_title')}>
          <InputWrapper>
            <div style={{ width: 180 }}>
              <AdornmentInput
                type="number"
                placeholder={t('payment_type_credit_label')}
                value={amount}
                onChange={onAmountChange}
                adornment="€"
              />
            </div>
          </InputWrapper>
        </QuestionMark>

        <ButtonWrapper>
          <SubmitButton onClick={onSubmit}>{t('continue')}</SubmitButton>
          <Information>
            {t('or')}
            &nbsp;
            <CustomLink href="#/" onClick={onSkip} color="inherit" underline="always">
              {t('skip')}
            </CustomLink>
          </Information>
        </ButtonWrapper>
      </div>
    </MainLayout>
  );
};

export default CreditPayment;
